// App.js
import './index.css';
import './App.css';
import './css/barbers.css';
import './css/contact.css';
import './css/footer.css';
import './css/gallery.css';
import './css/pricing.css';
import './css/styles.css';
import './css/testimonials.css';
import './css/services.css';

import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import Services from './components/Services';
import Barbers from './components/Barbers';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import BeforeAfterGallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';

import { Helmet } from 'react-helmet-async';

export default function App() {
  return (
    <>
      <Helmet>
        <title>Barbershop | Fresh Cuts & Grooming</title>
        <meta
          name="description"
          content="Classic and modern haircuts, hot towel shaves, and beard trims. Book online—walk-ins welcome."
        />
        <link rel="canonical" href="https://www.example.com/templates/barbershop" />
        <meta property="og:title" content="Fresh Cuts & Grooming" />
        <meta property="og:description" content="Premium barbershop services in your neighborhood." />
        <meta property="og:type" content="website" />
      </Helmet>

      <Header />
      <HeroBanner />
      <Services />
      <Barbers />
      <Pricing />
      <Testimonials />
      <BeforeAfterGallery />
      <Contact />
      <Footer />
    </>
  );
}
